export interface RefundVouchersFormDataBuilderInterface {
  voucherNo: string;
  email: string;
}
